import "./about.css";

const AboutPage = () => {
  return (
    <>
      <div className="tinas-section bg-1">
        <div style={{ padding: 40 }}></div>
        <div className="tinas-section-title">inspired by tina</div>
        <div className="tinas-section-text">
          more affectionately known as tima, she inspired this mava207 project
          (wip).
        </div>
        <div style={{ padding: 40 }}></div>
        <div className="tinas-section bg-2">
          <div className="tinas-section-title">some sketches</div>
          <img
            className="tinas-section-img"
            src="https://i.ibb.co/XyHk01v/Scan-20-May-2022-02-40-page-1.jpg"
          />
          <img
            className="tinas-section-img"
            src="https://i.ibb.co/MNx6qGT/Scan-20-May-2022-02-40-page-2.jpg"
          />
          <div style={{ padding: 40 }}></div>
        </div>
        <div className="tinas-section bg-1">
          <div className="tinas-section-title">first attempts</div>
          <img
            className="tinas-section-img"
            src="https://i.ibb.co/d5Z8049/tina-01.png"
          />
          <img
            className="tinas-section-img"
            src="https://i.ibb.co/4fncjnD/tina-02.png"
          />
          <div style={{ padding: 40 }}></div>
        </div>
        <div className="tinas-section bg-2">
          <div className="tinas-section-title">current progress</div>
          <img
            className="tinas-section-img"
            src="https://i.ibb.co/kxbF3GN/tina-03.png"
          />
          <img
            className="tinas-section-img"
            src="https://i.ibb.co/26bRQSS/tina-guides.png"
          />
          <img
            className="tinas-section-img"
            src="https://i.ibb.co/0Mq0V46/tina-mockup-icon.png"
          />
          <img
            className="tinas-section-img"
            src="https://i.ibb.co/bRh8psP/tina-mockup-web.jpg"
          />
          <div style={{ padding: 40 }}></div>
        </div>
      </div>
    </>
  );
};

export default AboutPage;
